import { atom } from 'recoil';
import { TUserState } from '@metadata';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'global-persist',
  storage: localStorage,
});

const globalState = atom<TUserState>({
  key: 'globalState',
  default: {
    UserInformation: {
      regUserId: '', //이름
      regUserName: '관리자',
      user_nm: '관리자',
      userId: '', //아이디
      ofcNm: '',
      CompanyID: '',
      CompanyName: '',
      ServiceID: '',
      token: '',
      ctpvNm: '',
      deptNm: '',
    },
    userService: {
      CROPS: '',
      FORST: '',
      OCEAN: '',
    },
    stae: {
      CROPS: '',
      FORST: '',
      OCEAN: '',
    },
    isLogin: false,
    isAdmin: true,
    currentPage: {
      title: '',
      url: '/',
    },
  },
  // effects: [getLocalStorageSession()],
  effects: [persistAtom],
});

export default globalState;
